import { render } from "./SaveMedication.vue?vue&type=template&id=1eabd564"
import script from "./SaveMedication.vue?vue&type=script&lang=js"
export * from "./SaveMedication.vue?vue&type=script&lang=js"

import "./SaveMedication.vue?vue&type=style&index=0&id=1eabd564&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__